import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import _uniqueId from 'lodash/uniqueId';
import React from 'react';

import {
  LegacyDateInput,
  LegacyFieldWrapper,
  LegacyFieldWrapperPropsFragment,
} from '~/legacy-components/LegacyForms';

import { DatePickerPropsFragment } from '../LegacyDateInput/component';

type Props<TDate> = LegacyFieldWrapperPropsFragment &
  DatePickerPropsFragment<TDate> & {
    inputSx?: SxProps<Theme>;
  };

export const LegacyDateField = <TDate,>(props: Props<TDate>) => {
  const {
    label,
    fieldError,
    required,
    highlightLabel,
    inputSx,
    ...dateInputProps
  } = props;

  const fieldId = _uniqueId('legacyInputField-');

  return (
    <LegacyFieldWrapper
      fieldId={fieldId}
      label={label}
      required={required}
      fieldError={fieldError}
      highlightLabel={highlightLabel}
    >
      <LegacyDateInput
        {...dateInputProps}
        id={fieldId}
        error={!!fieldError}
        sx={inputSx}
      />
    </LegacyFieldWrapper>
  );
};
